import { call, put, takeLatest } from 'redux-saga/effects';

import {
    USER_LOGOUT_REQUEST,
    LOAD_USER_REQUEST,
    GET_USER_NOTICE_REQUEST,
    SEE_USER_NOTICE_REQUEST,
    REMOVE_USER_NOTICE_REQUEST,
} from './constants';

import {
    logoutUserSuccess,
    logoutUserFailure,
    loadUserSuccess,
    loadUserFailure,
    getNoticeSuccess,
    getNoticeFailure,
    seeNoticeSuccess,
    seeNoticeFailure,
    removeNoticeSuccess,
    removeNoticeFailure,
} from "./actions";
import remote from '../../services/remote'
import {leaveChatRoom, onDisconnect} from "../Chat/actions";
import SentryManager from "../../monitoring/Sentry";

function* logout (action) {
    try {
        yield put(leaveChatRoom());
        yield put(onDisconnect());
        const response = yield call(remote, {
            route: '/account/logout',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            SentryManager.clearUserSession();
            yield put(logoutUserSuccess());
            // yield put(clearDentistId());
        } else {
            yield put(logoutUserFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* loadUser (action) {
    try {
        const response = yield call(remote, {
            route: '/me',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            const { id, username, email } = response.data;
            SentryManager.openUserSession({
                ...(id && { id }),
                ...(email && { email }),
                ...(username && { username }),
            });
            yield put(loadUserSuccess(response));
        } else {
            yield put(loadUserFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* getNotice (action) {
    try {
        const response = yield call(remote, {
            route: '/notifications/get-notice',
            method: 'get'
        });
        if (response.success) {
            yield put(getNoticeSuccess(response));
        } else {
            yield put(getNoticeFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* removeNotice (action) {
    try {
        const response = yield call(remote, {
            route: '/notifications/delete-notice',
            method: 'delete',
            body: JSON.stringify(action.data),
        });
        if (response.success) {
            yield put(removeNoticeSuccess(response));
        } else {
            yield put(removeNoticeFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* seeNotice (action) {
    try {
        const response = yield call(remote, {
            route: '/notifications/see-notice',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(seeNoticeSuccess(response));
        } else {
            yield put(seeNoticeFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

export default function* watchAuth() {
    yield takeLatest(USER_LOGOUT_REQUEST , logout);
    yield takeLatest(LOAD_USER_REQUEST , loadUser);
    yield takeLatest(GET_USER_NOTICE_REQUEST , getNotice);
    yield takeLatest(SEE_USER_NOTICE_REQUEST , seeNotice);
    yield takeLatest(REMOVE_USER_NOTICE_REQUEST , removeNotice);
}



// WEBPACK FOOTER //
// ./src/containers/AuthWrapper/saga.js